import { defaultFrTags } from 'containers/constants';

export function listDefaultTags(cycles: string[]) {
  const uniqueTitles = [
    ...new Set(cycles.flatMap(cycle => defaultFrTags[cycle] || [])),
  ];

  return uniqueTitles
    .map(title => ({
      value: title,
      label: title,
    }))
    .sort((a, b) => a.value.localeCompare(b.value));
}
